import { useEffect, useRef } from 'react';
import { InlineInput } from './editorStyles';

/** A heading that is typed directly in the report while editing. */
export function InlineText({
  value,
  placeholder,
  size,
  autoFocus,
  onChange,
  onFocused,
}: {
  value: string;
  size: 'section' | 'table';
  placeholder: string;
  autoFocus?: boolean;
  onChange: (value: string) => void;
  onFocused?: () => void;
}) {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (!autoFocus) return;
    ref.current?.focus();
    onFocused?.();
  }, [autoFocus, onFocused]);
  return (
    <InlineInput
      ref={ref}
      variant={size}
      value={value}
      placeholder={placeholder}
      maxLength={200}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === 'Escape') event.currentTarget.blur();
      }}
    />
  );
}
